import { render, staticRenderFns } from "./EmployeeCourseCustomerView.vue?vue&type=template&id=33b05f50&scoped=true"
import script from "./EmployeeCourseCustomerView.vue?vue&type=script&lang=js"
export * from "./EmployeeCourseCustomerView.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCourseCustomerView.vue?vue&type=style&index=0&id=33b05f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b05f50",
  null
  
)

export default component.exports